import axios from 'axios';
import env from 'consts/env';
import Cookies from 'js-cookie';

axios.defaults.withCredentials = true;

export const apiInstanceUnauthorized = axios.create({
  baseURL: `${env.API_ENDPOINT}/api${env.API_PREFIX}`
});

export const apiInstance = axios.create({
  baseURL: `${env.API_ENDPOINT}/api${env.API_PREFIX}`
});

apiInstance.interceptors.request.use(
  function (config) {
    const organization = Cookies.get('org');
    const token = Cookies.get('token');
    (config as any).headers['Authorization'] = `Bearer ${token}`;

    config.baseURL = `${config.baseURL}/${organization}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  function (config) {
    return config;
  },
  function (error) {
    // Do something with request error

    return Promise.reject(error);
  }
);

apiInstanceUnauthorized.interceptors.request.use(
  function (config) {
    const token = Cookies.get('token');
    (config as any).headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
